// extracted by mini-css-extract-plugin
module.exports = {"customersView":"customersView--1cMWb","customersTitle":"customersTitle--3zLwx","customersSeparator":"customersSeparator--3802l","customersMainBox":"customersMainBox--3se-q"};